import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import {
  createProductProperty,
  deleteProductProperty,
  getAllMainProductSync,
  getListMainproduct,
  updateProductProperty,
  getViewMainproduct,
  deleteProductMoloniProduct,
} from "../../services/MoloniServices";
import Select from "react-select";
import moment from "moment";

const ProductMainMoloni = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);
  const navigate = useNavigate();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tpsoft");

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: "269134",
    created_from: activeTab === "tpsoft" ? 1 : 2,
  });
  const { t } = useTranslation();

  const [totalRecords, setTotalRecords] = useState(0);
  const [productList, setProductList] = useState([]);
  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delType, setDelType] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [productData, setProductData] = useState({
    id: "",
    title: "",
    default: 0,
    moloni_id: "",
  });

  let errorsObj = {
    name: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [isProductLoading, setIsProductLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewProductData, setViewProductData] = useState("");
  const [viewProductStockData, setViewProductStockData] = useState("");

  const handleTabChange = (tab) => {
    setActiveTab(tab);

    setParams((prevParams) => ({
      ...prevParams,
      created_from: tab === "tpsoft" ? 1 : 2,
    }));
  };

  const handleCheckboxCashChange = (e) => {
    setProductData({
      ...productData,
      default: e.target.checked ? 1 : 0,
    });
  };

  const handleAddModal = () => {
    setModifyModal(true);
  };

  const handleCloseViewModal = () => {
    setViewModal(false);
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setProductData({
      id: "",
      title: "",
      default: 0,
      moloni_id: "",
    });

    setErrors("");
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  const fetchDocument = () => {
    let data = { ...params };
    getListMainproduct(data)
      .then((response) => {
        setProductList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchDocument(data);
    },
    [params]
  );

  const handleProductSync = () => {
    setIsProductLoading(true);

    let data = { company_id: "269134" };
    getAllMainProductSync(data)
      .then((response) => {
        toast.success(response.data.message);

        let data = { ...params };
        getListMainproduct(data)
          .then((response) => {
            setProductList(response.data.data);
            setTotalRecords(response.data.total);
            setIsProductLoading(false);

          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
            setIsProductLoading(false);

          })
          .finally(() => {
            setIsProductLoading(false);
          });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsProductLoading(false);
      });
  };

  const onViewProduct = (e, item) => {
    let data = { product_id: item?.moloni_id };
    getViewMainproduct(data)
      .then((response) => {
        toast.success(response.data.message);
        setViewProductData(response.data.data);
        setViewProductStockData(response.data.stock);

        setViewModal(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsProductLoading(false);
      });
  };

  const onDeleteModalClose = () => {
    setDelModal(false);
  };
  const onEditDetails = (e, item) => {
    setModifyModal(true);
    setProductData({
      id: item?.id,
      title: item?.title,
      default: item?.default,
      moloni_id: item?.moloni_id,
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelType(item.moloni_id);
    setDelModal(true);
  };

  const onDestroyBank = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { product_id: delType };
    deleteProductMoloniProduct(data)
      .then((response) => {
        let data = { ...params };

        fetchDocument(data);
        toast.success(response.data.message);
        setDelType("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    if (!productData.title) {
      errorObj.title = `title is required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      title: productData?.title,
      default: productData?.default,
    };

    let updateData = {
      company_id: "269134",
      id: productData?.id,
      title: productData?.title,
      default: productData?.default,
      property_id: productData?.moloni_id,
    };

    if (productData?.id) {
      updateProductProperty(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchDocument(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setProductData({
            id: "",
            title: "",
            default: 0,
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createProductProperty(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchDocument(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setProductData({
            id: "",
            title: "",
            default: 0,
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-products")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("products")}</h1>
              </div>

           
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control input-search"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder="Search"
                      ></input>
                    </div>

                    <div className="card-title m-0 float-right d-flex d-none">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        // onClick={handleAddModal}
                        onClick={() => {
                          navigate("/add-moloni");
                        }}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>

                      {activeTab === "moloni" && (
                        <button
                          type="button"
                          className="btn mr-2"
 style={{
                            background: "#81bb42",
                            width: "52px",
                            height: "36px",
                          }}                          onClick={handleProductSync}
                          disabled={isProductLoading}
                        >
                          {isProductLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="bi bi-arrow-repeat"></i>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                  <div className="card-body fuelCardB">
                    
                      <div className="tabs-section">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              className={`nav-link ${
                                activeTab === "tpsoft" ? "active" : ""
                              }`}
                              onClick={() => handleTabChange("tpsoft")}
                              style={{ cursor: "pointer" }}
                            >
                              TPSoft
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              className={`nav-link ${
                                activeTab === "moloni" ? "active" : ""
                              }`}
                              onClick={() => handleTabChange("moloni")}
                              style={{ cursor: "pointer" }}
                            >
                              Moloni
                            </a>
                          </li>
                        </ul>

                        <div className="tab-content">
                          <div
                            className={`tab-pane fade ${
                              activeTab === "tpsoft" ? "show active" : ""
                            }`}
                          >
                            <div
                              className="vehicleThBg table-responsive  table-responsive-vehicle"
                              style={{ marginTop: "15px" }}
                            >
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "10%" }}
                                    >
                                      {t("name")}
                                    </th>

                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "10%" }}
                                    >
                                      {t("price")}
                                    </th>

                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "0%" }}
                                    >
                                      {t("reference")}
                                    </th>

                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "0%" }}
                                    >
                                      {t("action")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {productList?.map((item, index) => {
                                    return (
                                      <>
                                        <tr>
                                          <td>{item.name}</td>
                                          <td>{item.price}</td>
                                          <td>{item.reference}</td>

                                          <td className="d-flex">
                                            <Dropdown
                                              className="iconDropdown"
                                              onToggle={(isOpen) => {
                                                if (isOpen) {
                                                  // This logic runs when the dropdown is opened
                                                  const tableResponsive =
                                                    document.querySelector(
                                                      ".table-responsive"
                                                    );
                                                  if (
                                                    window.innerWidth <= 767
                                                  ) {
                                                    if (tableResponsive) {
                                                      tableResponsive.style.overflowX =
                                                        "auto !important";
                                                      tableResponsive.style.overflowY =
                                                        "auto !important";
                                                    }
                                                  } else {
                                                    if (tableResponsive) {
                                                      tableResponsive.style.overflowX =
                                                        "inherit !important";
                                                      tableResponsive.style.overflowY =
                                                        "inherit !important";
                                                    }
                                                  }
                                                }
                                              }}
                                            >
                                              <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                                className="iconToggle"
                                              >
                                                <i className="bi bi-three-dots-vertical"></i>
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu>
                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex d-none"
                                                  onClick={(e) =>
                                                    navigate(
                                                      `/add-moloni/${item.moloni_id}`
                                                    )
                                                  }
                                                >
                                                  <div className="edit-btn">
                                                    <i className="bi bi-pencil"></i>
                                                  </div>
                                                  <span>{t("edit")}</span>
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                  href="#/action-2"
                                                  className="d-flex d-none"
                                                  onClick={(e) =>
                                                    onDeleteModalOpen(e, item)
                                                  }
                                                >
                                                  <div className="trash-btn">
                                                    <a className="delete-btn">
                                                      <i className="bi bi-trash3"></i>
                                                    </a>
                                                  </div>
                                                  <span>{t("delete")}</span>
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex"
                                                  onClick={(e) =>
                                                    onViewProduct(e, item)
                                                  }
                                                >
                                                  <div className="edit-btn">
                                                    <i className="bi bi-eye-fill"></i>
                                                  </div>
                                                  <span>{t("view")}</span>
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                                </tbody>
                                {productList && productList?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className={`text-center`}>
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                              </table>
                            </div>
                          </div>

                          <div
                            className={`tab-pane fade ${
                              activeTab === "moloni" ? "show active" : ""
                            }`}
                          >
                            <div
                              className="vehicleThBg table-responsive  table-responsive-vehicle"
                              style={{ marginTop: "15px" }}
                            >
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "10%" }}
                                    >
                                      {t("name")}
                                    </th>

                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "10%" }}
                                    >
                                      {t("price")}
                                    </th>

                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "0%" }}
                                    >
                                      {t("reference")}
                                    </th>
                                    <th
                                      className="col-form-label ml-2 Label-my form-label form-label"
                                      style={{ width: "0%" }}
                                    >
                                      {t("action")}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {productList?.map((item, index) => {
                                    return (
                                      <>
                                        <tr>
                                          <td>{item.name}</td>
                                          <td>{item.price}</td>
                                          <td>{item.reference}</td>

                                          <td className="d-flex">
                                            <Dropdown
                                              className="iconDropdown"
                                              onToggle={(isOpen) => {
                                                if (isOpen) {
                                                  // This logic runs when the dropdown is opened
                                                  const tableResponsive =
                                                    document.querySelector(
                                                      ".table-responsive"
                                                    );
                                                  if (
                                                    window.innerWidth <= 767
                                                  ) {
                                                    if (tableResponsive) {
                                                      tableResponsive.style.overflowX =
                                                        "auto !important";
                                                      tableResponsive.style.overflowY =
                                                        "auto !important";
                                                    }
                                                  } else {
                                                    if (tableResponsive) {
                                                      tableResponsive.style.overflowX =
                                                        "inherit !important";
                                                      tableResponsive.style.overflowY =
                                                        "inherit !important";
                                                    }
                                                  }
                                                }
                                              }}
                                            >
                                              <Dropdown.Toggle
                                                variant="success"
                                                id="dropdown-basic"
                                                className="iconToggle"
                                              >
                                                <i className="bi bi-three-dots-vertical"></i>
                                              </Dropdown.Toggle>

                                              <Dropdown.Menu>
                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex d-none"
                                                  onClick={(e) =>
                                                    navigate(
                                                      `/add-moloni/${item.moloni_id}`
                                                    )
                                                  }
                                                >
                                                  <div className="edit-btn">
                                                    <i className="bi bi-pencil"></i>
                                                  </div>
                                                  <span>{t("edit")}</span>
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                  href="#/action-2"
                                                  className="d-flex d-none"
                                                  onClick={(e) =>
                                                    onDeleteModalOpen(e, item)
                                                  }
                                                >
                                                  <div className="trash-btn">
                                                    <a className="delete-btn">
                                                      <i className="bi bi-trash3"></i>
                                                    </a>
                                                  </div>
                                                  <span>{t("delete")}</span>
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                  href="#/action-1"
                                                  className="d-flex "
                                                  // onClick={(e) =>
                                                  //   // onViewFuelType(e, item)
                                                  // }
                                                >
                                                  <div className="edit-btn">
                                                    <i className="bi bi-eye-fill"></i>
                                                  </div>
                                                  <span>{t("view")}</span>
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                                </tbody>
                                {productList && productList?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className={`text-center`}>
                                      {t("no_record_found")}
                                    </td>
                                  </tr>
                                )}
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer card-footer-part clearfix card-footer"
            style={{marginTop:"-26px"}}
            >
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{t("delete_product_properties")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("Are you sure you want to delete this product properties")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyBank}
            >
              {t("delete")} <i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader>{t("products")}</ModalHeader>
        <Form method={`post`} onSubmit={handleSubmitForm}>
          <ModalBody>
            <div className="row">
              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("title")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={productData.title}
                        onChange={(e) => {
                          setProductData({
                            ...productData,
                            title: e.target.value,
                          });
                        }}
                        name={`title`}
                        maxLength={50}
                        placeholder="Title"
                      />
                    </div>
                    {errors.title && (
                      <span className="input-error">{errors.title}</span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-6">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {t("default")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <div className="form-check">
                        <input
                          className="my-checkbox-1 form-check-input"
                          type="checkbox"
                          checked={productData.default === 1}
                          onChange={handleCheckboxCashChange}
                        />
                        <label className="form-check-label pl-6">
                          {t("default")}
                        </label>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("submit")} <i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={viewModal}>
        <ModalHeader>{t("details")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div
                    className="row"
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("product_name")}: {viewProductData?.name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("summary")}: {viewProductData?.summary || "-"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("category")}: {viewProductData?.category_name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("reference")}: {viewProductData?.reference || 0}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("price")}: {viewProductData?.price || 0}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("stock")}:{" "}
                        {viewProductData?.stock === 1 ? "Yes" : "No"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("minimum_stock")}:{" "}
                        {viewProductData?.minimum_stock || "-"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("warehouse")}: {viewProductData?.warehouse || "-"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("unit_name")}: {viewProductData?.unit_name || "-"}
                      </h6>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>

          <div className="row">
            <h6 style={{ fontSize: "22px" }}>{t("stock")}</h6>
            <div className="col-md-12">
              <FormGroup>
                <div
                  className="row"
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <div className="col-md-4">
                    <h6
                      style={{
                        marginBottom: "-1px",
                        marginLeft: "-8px",
                      }}
                    >
                      {t("warehouse")}:{" "}
                      {viewProductStockData?.warehouse_id || "-"}
                    </h6>
                  </div>

                  <div className="col-md-4">
                    <h6
                      style={{
                        marginBottom: "-1px",
                        marginLeft: "-8px",
                      }}
                    >
                      {t("document")}:{" "}
                      {viewProductStockData?.document_id || "-"}
                    </h6>
                  </div>
                  <div className="col-md-4">
                    <h6
                      style={{
                        marginBottom: "-1px",
                        marginLeft: "-8px",
                      }}
                    >
                      {t("quantity")}: {viewProductStockData?.qty || "-"}
                    </h6>
                  </div>

                  <div className="col-md-4">
                    <h6
                      style={{
                        marginBottom: "-1px",
                        marginLeft: "-8px",
                        marginTop: "11px",
                      }}
                    >
                      {t("movement_date")}:{" "}
                      {moment(viewProductStockData?.movement_date).format(
                        "DD/MM/YYYY"
                      )}
                    </h6>
                  </div>
                  <div className="col-md-4"></div>
                  <div className="col-md-4"></div>
                </div>
              </FormGroup>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCloseViewModal}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ProductMainMoloni;
